import React, {useEffect, useState} from 'react';
import {useInjex} from '@injex/react-plugin';
import {Badge, Button, Icon} from '@vidazoo/ui-kit';
import {CapitalAppsApi, ICapitalApp} from '../../../../../../common/api/CapitalAppsApi.mdl';
import {useMainMenuContext} from '../../contexts/MainMenuContext';
import theme from './theme.module.scss';

const GROUP = 'APPS_MENU';

export default function AppsMenu() {
    const [inject] = useInjex();
    const api = inject<CapitalAppsApi>('capitalAppsApi');
    const [apps, setApps] = useState<ICapitalApp[]>([]);
    const [loading, setLoading] = useState(true);
    const [failed, setFailed] = useState(false);
    const [expanded, setExpanded] = useState(false);
    const {selectedGroup, setSelectedGroup} = useMainMenuContext();
    const open = selectedGroup === GROUP;

    useEffect(() => {
        let active = true;
        api.getApps().then(items => { if (active) setApps(items); })
            .catch(() => { if (active) setFailed(true); })
            .finally(() => { if (active) setLoading(false); });
        return () => { active = false; };
    }, [api]);

    return <div className={theme.menu} onMouseEnter={() => setSelectedGroup(GROUP)} onMouseLeave={() => setSelectedGroup(null)}
        onKeyDown={event => { if (event.key === 'Escape') setSelectedGroup(null); }}>
        <button className={theme.trigger} type="button" aria-label="Vidazoo Apps" aria-expanded={open}
            onClick={() => setSelectedGroup(GROUP)}>
            <span className={theme.icon}>
                {!loading && !failed && <Badge className={theme.badge}>{apps.length}</Badge>}
                <Icon iconName="icon-grid" size={3}/>
            </span>
        </button>
        {open && <div className={theme.drawer}>
            <div className={theme.header}><Icon iconName="icon-network" size={2.4}/>Vidazoo Apps</div>
            {loading || failed ? <p className={theme.message}>{loading ? 'Loading apps…' : 'Unable to load apps.'}</p> :
                <div className={theme.apps}>
                    {(expanded ? apps : apps.slice(0, 9)).map(app => <a key={app.scope || app.clientUrl} href={app.clientUrl} target="_blank" rel="noopener noreferrer">
                        <img src={app.iconUrl} alt=""/><span>{app.displayName}</span>
                    </a>)}
                </div>}
            {apps.length > 9 && <Button gray60 medium fill onClick={() => setExpanded(!expanded)}>{expanded ? 'Show Less' : 'Show More'}</Button>}
        </div>}
    </div>;
}
